import Dashboard2 from "views/Dashboard/Dashboard2";
import UserProfile from "views/UserProfile/UserProfile";
import TableList from "views/TableList/TableList";
import Charts from "views/Charts/Charts";
import Admin from "views/Admin";
import Statistics from "views/Statistics";
import CollectionStatistics from "views/CollectionStatistics";
import Alarms from "views/Alarms/Alarms";
import Firmware from "views/Firmware";
import Notifications from "views/Notifications/Notifications";
//import Icons from "views/Icons/Icons";
//import Maps from "views/Maps/Maps";
//import Upgrade from "views/Upgrade/Upgrade";

const dashboardRoutes = [
  {
    path: "/dashboard",
    name: "Panel główny",
    icon: "pe-7s-graph",
    component: Dashboard2
  },

  {
    path: "/charts",
    name: "Wykresy",
    icon: "pe-7s-news-paper",
    component: Charts
  },
  {
    path: "/collection-statistics",
    name: "Statystyki odbiorów",
    icon: "pe-7s-display1",
    component: CollectionStatistics
  },
  {
    path: "/alarms",
    name: "Alarmy",
    icon: "pe-7s-alarm",
    component: Alarms
  },
  {
    path: "/user",
    name: "Użytkownik",
    icon: "pe-7s-user",
    component: UserProfile
  },
  {
    path: "/table",
    name: "Urządzenia",
    icon: "pe-7s-note2",
    component: TableList
  },
  {
    path: "/admin",
    name: "Zarządzanie",
    icon: "pe-7s-users",
    component: Admin,
    adminOnly: true
  },
  {
    path: "/statistics",
    name: "Statystyki",
    icon: "pe-7s-graph1",
    component: Statistics,
    adminOnly: true
  },
  {
    path: "/firmware",
    name: "Aktualizacje",
    icon: "pe-7s-cloud-upload",
    component: Firmware,
    adminOnly: true
  },

  {
    path: "/notifications",
    name: "Powiadomienia",
    icon: "pe-7s-bell",
    component: Notifications
  },

  { redirect: true, path: "/", to: "/dashboard", name: "Dashboard" }
];

export default dashboardRoutes;



// WEBPACK FOOTER //
// ./src/routes/dashboard.jsx